import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  BuyerPureScoreReportPayload,
  BuyerPureScoreReportResponse,
} from './buyer-purescore-script-report.interface';

@Injectable({
  providedIn: 'root',
})
export class BuyerPureScoreScriptReportService {
  private readonly _baseUrl = environment.pureSpectrum.url;

  constructor(private readonly _http: HttpClient) {}

  public getBuyerPureScoreReport<T = BuyerPureScoreReportResponse>(
    payloadObj: BuyerPureScoreReportPayload
  ): Observable<T> {
    const startDate = payloadObj.startDate ?? '';
    const endDate = payloadObj.endDate ?? '';
    const format = payloadObj.type || 'json';

    let url = `${this._baseUrl}/getBuyerPureScoreReport?startDate=${startDate}&endDate=${endDate}&buyerId=${payloadObj.buyerId}&format=${format}`;

    if (payloadObj.surveyId) {
      url += `&surveyId=${encodeURIComponent(payloadObj.surveyId)}`;
    }

    if (format === 'csv') {
      return this._http.get(url, { responseType: 'text' }) as Observable<T>;
    }

    return this._http.get<BuyerPureScoreReportResponse>(
      url
    ) as unknown as Observable<T>;
  }

  public downloadCsvReport(
    payloadObj: BuyerPureScoreReportPayload
  ): Observable<string> {
    payloadObj.type = 'csv';
    return this.getBuyerPureScoreReport(payloadObj) as Observable<string>;
  }
}
